import { render, staticRenderFns } from "./TimePeriodSelector.vue?vue&type=template&id=3668f04f&scoped=true&"
import script from "./TimePeriodSelector.vue?vue&type=script&lang=ts&"
export * from "./TimePeriodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TimePeriodSelector.vue?vue&type=style&index=0&id=3668f04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668f04f",
  null
  
)

export default component.exports